import React from 'react';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export default function FeatureCard({ icon, title, description }: FeatureCardProps) {
  return (
    <div className="group relative bg-gradient-to-br from-white via-primary-50/30 to-secondary-50/20 backdrop-blur-sm rounded-2xl p-8 hover:shadow-2xl transition-all duration-500 border border-primary-100/50 hover:border-primary-200 transform hover:-translate-y-2 animate-fade-in-up">
      {/* Gradient overlay on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-500/5 to-secondary-500/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      {/* Icon container with gradient background */}
      <div className="relative z-10 w-16 h-16 mb-6 bg-gradient-to-br from-primary-100 to-secondary-100 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
        <div className="text-primary-600 group-hover:text-primary-700 transition-colors duration-300 transform group-hover:scale-110">
          {icon}
        </div>
        {/* Subtle glow effect */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary-400/20 to-secondary-400/20 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      </div>
      
      <h3 className="relative z-10 text-xl font-bold text-primary-800 mb-4 group-hover:text-primary-900 transition-colors duration-300">
        {title}
      </h3>
      <p className="relative z-10 text-gray-600 leading-relaxed group-hover:text-gray-700 transition-colors duration-300">
        {description}
      </p>
      
      {/* Decorative corner accent */}
      <div className="absolute top-4 right-4 w-2 h-2 bg-gradient-to-br from-secondary-400 to-primary-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
    </div>
  );
}